import { Injectable } from '@angular/core'
import { RestServices } from '../../../rest.services'
import { AuthService } from '../../../auth.services'

@Injectable()
export class ClientTopRegistrationService {

    constructor(private restServices: RestServices,
                private  authService: AuthService) {
    }

}



// WEBPACK FOOTER //
// ./src/app/services/client/client-top/client-top-registration/client-top-registration.service.ts